/**
 * Created by chenguangjun on 2016/9/1.
 * 全局搜索 没见引用到
 */

const randomCharArray = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'

function* _getRandomLetter () {
  while (true) {
    let position = Math.floor(Math.random() * randomCharArray.length)
    yield randomCharArray[position]
  }
}

export default (length = 8) => {
  let r = ''
  let getRandomLetter = _getRandomLetter()
  for (let i = 0; i < length; i++) {
    r += getRandomLetter.next().value
  }
  return r
}
